import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

type ExternalFieldTarget =
  | {
      jsonPath: string;
      externalFieldId?: never;
    }
  | {
      jsonPath?: string;
      externalFieldId: string;
    };

export type SetExternalFieldsByLoanParams = {
  fieldValue: string;
  historyOrder?: string;
  historyTargetField?: 'VOD' | 'VOE' | 'VOR';
  loanId: string;
  encompassFieldId: string;
  documentId: string;
} & ExternalFieldTarget;

export interface SetExternalFieldsByLoanResponse {
  message: string;
}

const setExternalFieldsByLoan: MutationFunction<
  SetExternalFieldsByLoanResponse,
  SetExternalFieldsByLoanParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockType);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const jsonPath = args.jsonPath?.trim();
  const response = await authTokenHttp<SetExternalFieldsByLoanResponse>(
    `/loans/${args.loanId}/external-fields`,
    {
      method: 'PUT',
      body: {
        fieldValue: args.fieldValue,
        jsonPath: jsonPath || undefined,
        externalFieldId: jsonPath ? undefined : args.externalFieldId,
        historyOrder: args.historyOrder || undefined,
        historyTargetField: args.historyTargetField,
        encompassFieldId: args.encompassFieldId,
        documentId: args.documentId,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to set external fields');
};

export default setExternalFieldsByLoan;

const _mockType = {
  message: 'External field set successfully',
};
